import {createAnnotation} from './utils/createAnnotation'

/**
 * The annotation builder for the 'key' property of a component.
 */
export const htmlAttributes = createAnnotation('htmlAttributes')
